import React, { useCallback } from "react";
import { Tab, Tabs, createClasses } from "@bloomberg/media-ui-core";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { PlusThinStroke } from "@bloomberg/media-ui-icons";
import styles from "./styles.module.css";
import SignedOutSetupWatchlist from "~components/SignedOutSetupWatchlist";
import { GridFull } from "~components/Grid/GridFull";
import { NEW_PORTFOLIO_TAB_TITLE } from "~constants/Portfolio";

export default function AnonymousUser() {
  const { client } = useRegUIClient();

  const signInButtonClickHandler = useCallback(
    () => client?.linkToSignIn(),
    [client]
  );

  const createAccountButtonClickHandler = useCallback(
    () => client?.linkToRegister(),
    [client]
  );

  return (
    <Tabs
      className={createClasses(styles.tabbedView, styles.outsideGrid)}
      variant="default"
    >
      {[
        <Tab
          className={createClasses(styles.tabContent, styles.gridLayout)}
          title={NEW_PORTFOLIO_TAB_TITLE}
          key={NEW_PORTFOLIO_TAB_TITLE}
          isActive
          isDefault
          Icon={<PlusThinStroke />}
        >
          <GridFull>
            <SignedOutSetupWatchlist
              signInModal={signInButtonClickHandler}
              registerModal={createAccountButtonClickHandler}
            />
          </GridFull>
        </Tab>,
      ]}
    </Tabs>
  );
}
